import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { LoadingIndicator } from '@dojo/widgets/loading-indicator';
import { childmap, createNlsMiddleware, keymap, lccstate, pathmap, userstate } from 'lcc-state';
import css from '../../css/progress-view.m.css';
import { svc, ScoreToast, MicroCard } from '../index';
const factory = create({
    icache: createICacheMiddleware(),
    nls: createNlsMiddleware('ditabook'),
    theme,
    lccstate,
    userstate
});
export const AllTestsPanel = factory(({ middleware: { icache, theme, lccstate, userstate, nls } }) => {
    const { messages: { assess_progress_not_started = '[ditabook] assess_progress_not_started', assess_progress_threshold_low_label = '[ditabook] assess_progress_threshold_low_label', assess_progress_threshold_mid_label = '[ditabook] assess_progress_threshold_mid_label', assess_progress_threshold_high_label = '[ditabook] assess_progress_threshold_high_label' } } = nls();
    const alertMessages = {
        none: assess_progress_not_started,
        low: assess_progress_threshold_low_label,
        mid: assess_progress_threshold_mid_label,
        high: assess_progress_threshold_high_label
    };
    const { get, path } = lccstate;
    const { get: uget, path: upath } = userstate;
    const { portal_site: site, portal_userid: userid, product: product_id, course_session } = window.hcstatic;
    const session_id = course_session && course_session.pk;
    const themeCss = theme.classes(css);
    const allBestScores = icache.getOrSet('best_scores', async () => {
        const member_id = userid || '';
        const data = await svc.module_best({ member_id, product_id, session_id, site });
        return data;
    });
    const status = uget(upath('status'));
    const roots = get(path('ditaroots'));
    const topicsets = roots.flatMap((root) => {
        const kidkeys = childmap.get(root) || [];
        return kidkeys.map((tgf) => {
            const { path } = keymap.get(tgf);
            const { topic: { topicset } } = pathmap.get(path);
            const progress = status[tgf];
            return { topicset, progress };
        });
    });
    const groupedTopicsets = topicsets.reduce((acc, tgf, index) => {
        const itemsPerColumn = Math.ceil(topicsets.length / 3);
        const rawColumnIndex = Math.floor(index / itemsPerColumn);
        const columnIndex = Math.min(2, rawColumnIndex);
        if (!acc[columnIndex]) {
            acc[columnIndex] = [];
        }
        acc[columnIndex].push(tgf);
        return acc;
    }, []);
    return v('div', { classes: [themeCss.progressContainer] }, allBestScores
        ? [
            v('div', { classes: [themeCss.panels] }, groupedTopicsets.map((group) => v('div', { classes: [themeCss.panelColumn] }, group.map((tgf) => {
                const { topicset, progress } = tgf;
                const { data } = progress;
                const isquizcompleted = data.pointsincorrect > 0 || data.pointscorrect > 0;
                const rawScore = data.percent < 1 ? data.percent * 100 : data.percent;
                const score = Math.round(isquizcompleted ? rawScore : -1);
                const bestScoreRecord = allBestScores?.find((qs) => qs.quiz_id === topicset.attributes?.key && qs.score.completed);
                const bestScore = bestScoreRecord ? parseInt(bestScoreRecord.score.score) : -1;
                return w(MicroCard, {
                    topic: topicset,
                    onAction: () => { },
                    showProgress: true,
                    titleOnly: true,
                    bestQuizScore: bestScore
                }, [w(ScoreToast, { score, messages: alertMessages })]);
            }))))
        ]
        : [w(LoadingIndicator, { active: true, type: 'circular-medium' })]);
});
export default AllTestsPanel;
